export interface LoginCardBranding {
  cardOpacity?: number | null;
}

export function buildLoginCardCssRules(
  s: string,
  branding: LoginCardBranding | null | undefined,
): string[] {
  const raw = branding?.cardOpacity;
  if (typeof raw !== "number" || Number.isNaN(raw)) {
    return [];
  }
  const opacity = Math.min(1, Math.max(0, raw));
  if (opacity >= 1) {
    return [];
  }
  return [
    `${s}[data-ui="login-card"] { background-color: rgba(255, 255, 255, ${opacity}); }`,
  ];
}
